import { useEffect, useState } from 'react';
import styles from './CommissionScreen.module.css';
import { useTranslation } from 'react-i18next';

const CommissionScreen = ({
  affiliateName,
  commissionPercentage,
  messageLoyalty,
  handleVerifyAccount,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className='mt-3'>
      <div className={`${styles.content} ${isVisible ? styles.visible : ''}`}>
        <div className='text-center mb-4'>
          <div className={styles.iconWrapper}>
            <svg
              className={styles.icon}
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <path d='M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' />
            </svg>
          </div>
          <h1 className='bold font-extra-large'>{t('affiliateCommissionTitle')}</h1>
        </div>

        <div className={styles.infoCard}>
          <div className={styles.infoRow}>
            <span className='text-secondary semi-bold font-small'>{t('affiliateLabel')}</span>
            <span className='font-1rem  fw-semibold'>{affiliateName}</span>
          </div>
        </div>

        <div className={styles.commissionCard}>
          <div className='text-lighter-gray semi-bold font-small mb-2'>{t('yourCommission')}</div>
          <div className={styles.commissionValue}>
            <span className={styles.percentage}>{commissionPercentage}</span>
            <span className={styles.percentSymbol}>%</span>
          </div>
          <div className='text-lighter-gray semi-bold font-small '>{t('onFinalConsumption')}</div>
        </div>

        <div className={styles.disclaimer}>
          <span className={styles.asterisk}>*</span>
          <p className='text-secondary font-tiny '>{t('commissionDisclaimer')}</p>
        </div>

        {messageLoyalty && (
          <div className={styles.loyaltyBanner} onClick={handleVerifyAccount}>
            <div className={styles.loyaltyContent}>
              <div className={styles.loyaltyIcon}>
                <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <path d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' />
                </svg>
              </div>
              <div className={styles.loyaltyText}>
                <div className={styles.loyaltyTitle}>{t('wantMoreCommission')}</div>
                <div className={styles.loyaltyDescription}>{t('verifyProfessionalDocs')}</div>
              </div>
            </div>
            <div className={styles.loyaltyArrow}>
              <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'>
                <path d='M9 5l7 7-7 7' />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommissionScreen;
